/* 馬超傳・第 5 章上半：冀城（上）圍城（建安十七年，212）
 * 史實：〈馬超傳〉「超果率諸戎以擊隴上郡縣，隴上郡縣皆應之，殺涼州刺史韋康，據冀城，有其眾。」
 *       〈楊阜傳〉楊阜守冀城「自正月至八月拒守而救兵不至」；「刺史、太守卒遣人請和，開城門迎超。超入，拘岳於冀，使楊昂殺刺史、太守。」
 *       《夏侯淵傳》「馬超圍涼州刺史韋康於冀，淵救康，未到，康敗。」《後漢書·獻帝紀》建安十七年「八月，馬超破涼州，殺刺史韋康」。
 *       開頭的旁白：《後漢書·獻帝紀》建安十七年「夏五月癸未，誅衞尉馬騰，夷三族」。
 * 流程：圍住冀城；東邊的糧隊一支支往城裡送糧，截下糧車城中士氣就掉，讓糧車進城士氣就回升。
 *       城中士氣歸零，韋康開城；夏侯淵的救兵趕到之前沒拿下就失敗。打完接第二幕「鹵城」（def.next）。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, vanish, troop } from '../kit.ts';
import { band } from './machao_kit.ts';
import { JI, JI_GATE, CAMP, EAST } from '../maps/machao_jicheng.ts';

const LV = 14, RELIEF = 200, EVERY = 16;
const ZHOU = troop('liang-soldier', '州兵', { armor: '#4a5a6a', sleeve: '#3a4652', cloth: '#3a4652', plume: '#8a9aaa' });
const ESCORT = { spec: ZHOU, name: '州兵', hp: 480, maxHp: 480, atk: 24 };

export default {
  id: 'machao-5a', map: 'machao_jicheng', hero: 'machao',
  next: 'machao-5', // 第二幕：鹵城（評星在第二幕）
  title: '第 5 章　冀城（上）', year: '建安十七年（212）',
  brief: {
    quote: [{ text: '殺涼州刺史韋康，據冀城，有其眾。', src: '《三國志·蜀書·馬超傳》' }],
    text: '渭南兵敗，馬超退回隴上。父親馬騰當時在鄴城任衛尉，被曹操誅殺。馬超率羌、氐諸戎攻打隴上郡縣，把涼州刺史韋康圍在冀城。',
    goals: ['截下送進冀城的糧隊', '城中士氣歸零，韋康開城', '（下半）鹵城'],
  },
  words: { ally: '西涼騎', foe: '州兵' },
  steps: [
    { // 0. 圍城
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 200; me.y = CAMP[1] - 300;
        V.t0 = w.t; V.morale = 100; V.cut = 0; V.fed = 0; V.next = 4; V.carts = [];
        m.card('夏五月癸未，誅衞尉馬騰，夷三族。', '《後漢書·獻帝紀》');
        V.pd = ally(w, 'pangde', me.x - 80, me.y + 90, LV);
        V.men = band(m, me, 10, '羌騎', { hp: 620, atk: 26 });
        m.gate('ji', JI_GATE[0], JI_GATE[1], 190, 'citygate');
        m.after(3, () => m.line('馬超', '……父親。（握緊了槍）圍住冀城，一粒米也別讓它進去。'));
        m.after(7, () => m.line('提示', '糧隊從東邊沿路往冀城南門走。打掉糧車，城中士氣就掉；讓糧車進了城，士氣就回升。'));
        m.mark('ji', JI.x, JI.y, '冀城');
        m.obj('siege', '');
      },
      tick(m, w, dt) {
        const V = m.vars, t = w.t - V.t0, left = RELIEF - t;
        V.morale = Math.max(0, V.morale - dt * 0.45);
        // 糧隊
        if ((V.next -= dt) <= 0) {
          V.next = EVERY;
          const cart = m.foe('huangjin', EAST[0], EAST[1], { spec: ZHOU, name: '糧車', hp: 1100, maxHp: 1100, atk: 0, ms: 130, range: 0, gold: 60, xp: 80, r: 30 });
          cart.cart = true; cart.home = [JI_GATE[0], JI_GATE[1] + 160]; V.carts.push(cart);
          for (let i = 0; i < 3; i++) { const u = m.foe('huangjin', EAST[0] + 80 + i * 60, EAST[1] + (i - 1) * 90, ESCORT); u.escort = cart; }
          m.mark('cart' + V.carts.length, cart.x, cart.y, '糧車', true, cart);
        }
        for (const [k, c] of V.carts.entries()) {
          if (c.done) continue;
          if (!c.alive) { c.done = true; V.cut++; V.morale = Math.max(0, V.morale - 10); m.unmark('cart' + (k + 1)); m.line('西涼騎', '糧車燒了！'); continue; }
          c.target = null; c.think = 1; // 糧車只顧往城裡走
          if (SG.gd(c.x, c.y, c.home[0], c.home[1]) < 120) { c.done = true; V.fed++; V.morale = Math.min(100, V.morale + 15); m.unmark('cart' + (k + 1)); vanish(w, c); m.line('州兵', '糧食進城了！'); }
        }
        for (const u of w.units) if (u.escort && u.alive && !(u.target && u.target.alive)) u.home = [u.escort.x + 60, u.escort.y + 60]; // 護糧的兵跟著糧車
        m.get('siege').text = `圍冀城：城中士氣 ${Math.ceil(V.morale)}%（截糧 ${V.cut}、進城 ${V.fed}；夏侯淵救兵 ${Math.max(0, Math.ceil(left))} 秒後到）`;
        if (left <= 0) { m.lose('夏侯淵的救兵到了，圍城失敗'); return false; }
        return V.morale <= 0;
      },
    },
    { // 1. 韋康開城
      enter(m, w) {
        const V = m.vars;
        V.fallT = w.t - V.t0;
        m.done('siege'); m.unmark('ji');
        m.ungate('ji');
        for (const c of V.carts) if (c.alive) vanish(w, c);
        m.card('自正月至八月拒守而救兵不至。', '《三國志·魏書·楊阜傳》');
        m.after(3, () => { m.big('韋康開城'); m.card('刺史、太守卒遣人請和，開城門迎超。超入，拘岳於冀，使楊昂殺刺史、太守。', '〈楊阜傳〉'); });
        m.after(7, () => m.card('淵救康，未到，康敗。', '《三國志·魏書·夏侯淵傳》'));
        m.after(10, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('馬超陣亡'); return; }
    if (m.vars.pd) allyTick(w, m.vars.pd, w.player, 450);
  },
};
